import React from 'react';

import groupImages from '../../asstes/login/Group_Image.png';

function Right_panel() {
  return (
    <div className='md-1:hidden md:grid md:grid-col-7 md:col-span-2 bg-blue-3 h-screen'>
          {/* empty div to manage spacing */}
            <div></div>
            {/* Title Section */}
            <div className='grid grid-col content-center row-span-3'>
              <div className='bg-black-1 text-white-1 text-center text-7xl 1xl:text-7xl-1 tall:text-5xl font-bold mx-auto py-5 px-10'><span className='text-blue-1'>ONE APP, ALL</span> FREE.</div>
            </div>
            {/* Crousel Section */}
            <div className='grid content-center row-span-2 overflow-hidden'>
              <div className='flex justify-center -mx-32'>
                  <img src={groupImages} className='object-fit' alt="" />
              </div>
            </div>
            {/* Subtitle Section */}
            <div className='grid grid-col content-center -mt-28 mb-10'>
              <div className='text-white-1 text-center  font-semibold text-6xl tall:text-4xl'>PROFILE SCANNING.</div>
              <div className='text-white-1 text-center  font-semibold text-6xl tall:text-4xl'>CANDIDATE TRACKING.</div>
            </div>
        </div>
  )
}

export default Right_panel